var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper chiller-theme",attrs:{"id":"main"}},[_c('main-sidebar'),_vm._v(" "),_c('main',{staticClass:"page-content"},[_c('main-header'),_vm._v(" "),(_vm.$store.getters.selectedTab === 'ckone')?_c('c-k-one'):_vm._e(),_vm._v(" "),(_vm.$store.getters.selectedTab === 'xstore')?_c('x-store'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38e86d00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobileapps/main/Index.vue
// module id = null
// module chunks = 